
import React from 'react';

const bigA = () => {
	return (
		<div>
			<svg 
				version="1.1" 
				id="a-big" 
				xmlns="http://www.w3.org/2000/svg" 
				xmlnsXlink="http://www.w3.org/1999/xlink" 
				x="0px" 
				y="0px"
				viewBox="0 0 157.2578 203.7103" 
				style={{enableBackground: 'new 0 0 157.2578 203.7103'}} 
				xmlSpace="preserve"
			>
				<g className="st0">
					<g fill="none">
						<path 
							className="st7-1"
							id="st7-1"
							stroke="#4d4d4e"
							strokeDasharray= "1238"
							strokeDashoffset="1238"
							d="M33.733,0.9744l122.4033,143.93l-34.6376,13.2961L97.5581,128.164l-56.0107,21.5005l2.4175,38.2984
							L9.3273,201.2591L3.6589,12.5187L33.733,0.9744z M97.6965,127.5807l23.9406,30.0364l33.6902-12.9324L33.6135,1.56L4.1474,12.871
							l5.6341,187.6836l33.6902-12.9324l-2.4175-38.2984L97.6965,127.5807"
						>
							<animate 
								xlinkHref="#st7-1" 
								attributeName="stroke-dashoffset" 
								begin="1s" 
								values="1238; 0" 
								dur="3s" 
								repeatCount="1"  
								fill="freeze"  
								calcMode="linear"
							/>
						</path>
					</g>
					<g fill="none">
						<path 
							className="st7-2"
							id="st7-2"
							stroke="#4d4d4e"
							strokeDasharray= "362"
							strokeDashoffset="362"
							d="M39.061,118.4976l-4.5075-70.2924l44.117,55.4348l-39.5881,15.1964L39.061,118.4976z M77.8852,103.4113
							L35.1257,49.6725l4.3872,68.4685L77.8852,103.4113"
						>
							<animate 
								xlinkHref="#st7-2" 
								attributeName="stroke-dashoffset" 
								begin="1s" 
								values="362; 0" 
								dur="3s" 
								repeatCount="1"  
								fill="freeze"  
								calcMode="linear"
							/>
						</path>
					</g>
				</g>
			</svg>
		</div>
	);
};

export default bigA;